import { CommunicationTemplateType } from "@bbj-types/communication/enum";
import { EmailModalDescription } from "./emailModalContent/description";
import { SmsModalDescription } from "./smsModalContent/description";

export interface INotifyCandidateModalDescriptionProps {
  type: CommunicationTemplateType;
  candidatesCount: number;
  eligibleCandidatesCount: number;
}

export const NotifyCandidateModalDescription = ({
  type,
  candidatesCount,
  eligibleCandidatesCount,
}: INotifyCandidateModalDescriptionProps) => {
  switch (type) {
    case CommunicationTemplateType.EMAIL:
      return (
        <EmailModalDescription candidatesCount={candidatesCount} eligibleCandidatesCount={eligibleCandidatesCount} />
      );
    case CommunicationTemplateType.SMS:
      return (
        <SmsModalDescription candidatesCount={candidatesCount} eligibleCandidatesCount={eligibleCandidatesCount} />
      );
    default:
      return null;
  }
};
